export class Client {
  firstName: string;
  lastName: string;
  companyName: string;
  clientMail: string;
  mailBody: string;

  constructor(data?: any) {
    data = data || data.id;
    this.firstName = data.firstName;
    this.lastName = data.lastName;
    this.companyName = data.companyName;
    this.clientMail = data.clientMail;
    this.mailBody = data.mailBody;
  }
}
